import IngestionConfig from '../../../../types/ingestion/IngestionConfig';
import Dictionary from '../../../../types/report/Dictionary';
import DictionaryField from '../../../../types/report/DictionaryField';
import ErrorType from '../../../../types/report/ErrorType';
import UserDefinedFunction from '../../../../types/report/UserDefinedFunction';
import clear from '../../common/array/clear';
import stringHelper from '../../common/stringHelper';
import declarationValidator from './declarationValidator';
import uniquenessValidator from './uniquenessValidator';

const maxNameCharacters = 50;

const validateDictionaryField = (field: DictionaryField, functions: UserDefinedFunction[], globalFunctions: UserDefinedFunction[], dictionaries: Dictionary[], dataSources: IngestionConfig[], reportConfigType:string): void => {

    clear(field.errors);

    if (stringHelper.isEmpty(field.name)) {
        field.errors.push('Field name is required');
    }

    if (field.name.length > maxNameCharacters) {
        field.errors.push(`Parameter name max character count is ${maxNameCharacters}`);
    }

    declarationValidator.validate(field, functions, globalFunctions, [], dictionaries, [], dataSources, [], null as any, field.dataType, null, true, reportConfigType);
};

const validateDictionaryFields = (functions: UserDefinedFunction[], globalFunctions: UserDefinedFunction[], dictionaries: Dictionary[], dataSources: IngestionConfig[], reportConfigType:string): ErrorType => {

    dictionaries.forEach((x) => {
        x.fields.forEach((f) => validateDictionaryField(f, functions, globalFunctions, dictionaries, dataSources, reportConfigType));
    });

    let dictionaryWithErrorFields = dictionaries.find(x => x.fields.some(f => f.errors.length > 0));

    let fieldWithErrors = dictionaryWithErrorFields?.fields?.find(x => x.errors.length > 0);

    return {
        mainConmponentNumber: dictionaryWithErrorFields?.number,
        componentNumber: fieldWithErrors?.number,
        message: fieldWithErrors?.number ? 'Invalid dictionary field' : ''
    } as ErrorType
}

const validateDictionary = (dictionary: Dictionary, functions: UserDefinedFunction[], dictionaries: Dictionary[], dataSources: IngestionConfig[]): void => {

    clear(dictionary.errors);

    let metadataError = validateMetadata(dictionary);
    if (metadataError) {
        dictionary.errors.push(metadataError);
    }

};

const validateDictionaries = (dictionaries: Dictionary[], functions: UserDefinedFunction[], dataSources: IngestionConfig[]): ErrorType => {

    dictionaries.forEach(x => validateDictionary(x, functions, dictionaries, dataSources));

    uniquenessValidator.validate(dictionaries, a => a.name, 'Dictionary', 'name');

    let dictionaryWithError = dictionaries.find(x => x.errors.length > 0);

    return {
        componentNumber: dictionaryWithError?.number,
        message: dictionaryWithError ? 'Invalid dictionary' : ''
    } as ErrorType;
};

const validateMetadata = (dictionary: Dictionary): string | null => {

    if (stringHelper.isEmpty(dictionary.name)) {
        return 'Dictionary name is required';
    }

    if (dictionary.name.length > maxNameCharacters) {
        return `Dictionary name max character count is ${maxNameCharacters}`;
    }

    if (dictionary.fields.length === 0) {
        return 'At least one field is required';
    }

    return null;
};

const dictionaryValidator = {
    validateDictionaryFields,
    validateDictionaryField,
    validateDictionaries
};

export default dictionaryValidator;
